import { Link } from '@reach/router';
import styled, { css } from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  media,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding-bottom: ${space[6]};
`;

export const WelcomeHeader = styled.h1`
  margin: ${space[6]} ${layout.gutter} ${space[5]};
  color: ${({ theme }) => theme.headerColour};
  text-align: center;
  font-weight: ${fontWeight.heavy};
  font-size: ${fontSize.xxl};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;

  ${media.md`
    max-width: ${layout.contentMaxWidth};
    margin: ${space[7]} auto ${space[5]};
    padding: 0 ${layout.gutterWide};
    text-align: left;
    font-size: ${fontSize.display};
  `}
`;

export const ClassroomHeader = styled.h2`
  margin: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;
`;

export const ParticipantsText = styled.p`
  margin: ${space[1]} 0 0;
  font-size: ${fontSize.sm};
  opacity: 0.9;
`;

export const ClassroomPlaceholder = styled.h2`
  margin: 0;
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.tight};
`;

export const HomeHeader = styled.h2`
  margin: ${space[6]} ${layout.gutter} ${space[3]};
  color: ${({ theme }) => theme.headerColour};
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};

  ${media.md`
    max-width: ${layout.contentMaxWidth};
    margin: ${space[7]} auto ${space[4]};
    padding: 0 ${layout.gutterWide};
  `}
`;

export const UnstyledLink = styled(Link)`
  display: flex;
  gap: ${space[4]};
  min-width: 0;
  color: inherit;
  text-decoration: inherit;
  border-radius: ${radius.md};

  &::after {
    /* makes the whole card the tap target */
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: ${radius.lg};
  }
`;

export const LessonLink = styled(UnstyledLink)`
  align-items: center;
`;

export const ModuleLessonLink = styled(LessonLink)`
  align-self: stretch;
`;

export const LessonThumb = styled.img`
  flex-shrink: 0;
  width: 6.4rem;
  height: 6.4rem;
  border: 3px solid ${({ theme }) => theme.textLight};
  border-radius: ${radius.md};
  background-color: ${({ theme }) => theme.appBackground};
  box-shadow: ${shadow.sm};
  object-fit: cover;
`;

export const ProfileThumb = styled(LessonThumb)`
  object-fit: cover;
`;

export const Logos = styled.div`
  display: flex;
  justify-content: ${({ single }) => (single ? 'center' : 'space-between')};
  align-items: center;
  gap: ${space[4]};
  margin: ${space[6]} ${layout.gutter} 0;
  ${({ empty }) =>
    empty &&
    css`
      height: 4em;
    `}
`;

export const AppLogo = styled.img`
  height: 8rem;
  max-width: 100%;
  object-fit: contain;
  margin: ${space[7]} 0 ${space[4]};
`;

export const HomeCardLi = styled.li`
  display: flex;
  list-style: none;
  margin: 0;
`;

export * from '../../common/elements/Cards';
export * from '../../common/elements/Form';
export * from '../../common/elements/Notifications';
export * from '../../common/elements/Staff';
export * from '../../common/elements/Students';
